if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}























document.addEventListener('DOMContentLoaded', function() {
  const pForm = document.querySelector('product-form');
  if (!pForm || !window.location.pathname.includes('cedar')) return;

  let sTexture = 'Fuzzy';
  let sColor = 'Black';

  // UI Listeners for Saucer Buttons only
  document.querySelectorAll('.manual-configurator button').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      this.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      
      if (this.dataset.type === 's-texture') {
        sTexture = this.dataset.val;
        document.getElementById('s-texture-val').innerText = sTexture;
      } else {
        sColor = this.dataset.val;
        document.getElementById('s-color-val').innerText = sColor;
      }
    });
  });

  const addBtn = pForm.querySelector('[name="add"]');
  addBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // 1. Let the App handle the Planter ID
    // This grabs whatever the form currently thinks is selected (Globo's choice)
    const planterId = pForm.querySelector('input[name="id"]').value;
    
    // 2. Find the current Size from Globo's first row
    const sizeElem = document.querySelector('.globo-swatch-item.active[data-option-index="0"]');
    const selectedSize = sizeElem ? sizeElem.getAttribute('data-tool-tip') : "2\"";

    // 3. Match our manual Saucer choice
    const saucerMatch = Array.from(document.querySelectorAll('.s-var')).find(v => 
      v.dataset.size === selectedSize && v.dataset.text === sTexture && v.dataset.col === sColor
    );

    const items = [{ id: planterId, quantity: 1 }];
    if (saucerMatch) {
      items.push({ id: saucerMatch.dataset.id, quantity: 1 });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(res => { 
      if (res.ok) window.location.href = '/cart'; 
    });
  });
});